import React from 'react';
import classes from './SocialIcons.module.css';
import cancelIcon from '../assets/images/cancelIco.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedinIn, faFacebookF, faFacebookMessenger } from '@fortawesome/free-brands-svg-icons';
import { useState } from 'react';
import { useDarkmodeContext } from '../contexts/DarkmodeContext';

const SocialIcons = () => {
    const [toggler, setToggler] = useState(false)
    const { darkMode } = useDarkmodeContext();

    const socialToggleHandler = () => {
        setToggler(prevCheck => !prevCheck)
    }

    return (
        <div className={`${classes['social-icon']} ${darkMode && classes.darker}`}>
            <span onClick={socialToggleHandler} className={`${classes["social-toggle"]} d-inline-block d-lg-none`}>
                {toggler ? <img src={cancelIcon} alt="" /> : <FontAwesomeIcon className={classes.my_icon} icon={faFacebookMessenger} />}

            </span>

            <div className={toggler ? `${classes["social-icon-wrapper"]} ${classes.open}` : `${classes["social-icon-wrapper"]}`}>
                <a href="https://github.com/fahimeshti" rel="noreferrer" target="_blank">
                    <span className={classes.icon}>
                        <FontAwesomeIcon icon={faGithub} />
                    </span>
                </a>
                <a href="https://www.linkedin.com/in/eshtiyak-fahim/" rel="noreferrer" target="_blank">
                    <span className={classes.icon}>
                        <FontAwesomeIcon icon={faLinkedinIn} />
                    </span>
                </a>
                <a href="https://www.facebook.com/eshtiyak.fahim/" rel="noreferrer" target="_blank">
                    <span className={classes.icon}>
                        <FontAwesomeIcon icon={faFacebookF} />
                    </span>
                </a>
            </div>
        </div>
    );
};

export default SocialIcons;